import { environment } from 'environments/environment';
export enum AZIONI {
  Login = 1,
  RichiestaRecuperoPassword = 2,
  ClickBannerPostLogin = 3,
  ClickBannerHome = 4,
  Navigazione = 5,
  ClickLinkEvidenza = 6
}
export enum NAVIGAZIONE {
  Home = 1,
  Corsi = 2,
  GDPR = 3,
  FatturazioneElettronica = 4,
  DVR = 5,
  UDI = 6,
  CalcolaValoreStudio = 7,
  RIS = 8,
  ManualiANDI = 9,
  VideoComunicazionePaziente = 10,
  ProntuarioFarmaceutico = 11,
  QuestionarioAntibioticoResistenza = 12,
  Adesioni = 13,
  Compass = 14,
  Confprofessioni = 15,
  Assicurazione = 16,
  Impostazioni = 17,
  RichiediPEC = 18,
  Assistenza = 19,
  CentriDiCosto = 20,
  AccediPec = 21,
  ANDISites = 22,
  FinanzaAgevolataBandi = 23,
  SportelloUnico = 24,
  CongressoScientifico = 25,
  AssicurazioneAIMUW = 26
}
export enum TIPOSEZIONE {
  Nazionale = 1,
  Dipartimento = 2,
  Sezione = 3
}
export enum CONSENSIPRIVACY {
  PEC = 1,
  PEC_SILVER = 2,
  COMPASS = 3,
  CONFPROFESSIONI = 4,
  TEAMVIEWER = 5,
  DVR = 6
}
export enum TIPOLINK {
  Comunicazione = 1,
  Avviso = 2,
  LinkInEvidenza = 3
}
export enum CostantiStorage {
  URLPRELOGOUT = 'URLPRELOGOUT',
  AKITASTORE = 'AkitaStores',
  STATE = 'STATE',
  TOKEN = 'TOKEN',
  TOKENPASS = 'TOKENPASS',
  AGGIORNAMENTO_DATI_PENDING = 'AGGIORNAMENTO_DATI_PENDING',
  IDSCREENLOCKED = 'IDSCREENLOCKED',
  IDDETTPROFILO = 'IDDETTPROFILO',
  IDSTUDIOATTIVO = 'IDSTUDIOATTIVO',
  IDSTUDIOATTIVOCDC = 'IDSTUDIOATTIVOCDC',
  IDSTUDIOATTIVOMAGAZZINO = 'IDSTUDIOATTIVOMAGAZZINO',
  TIPOCREAZIONE = 'TIPOCREAZIONE',
  IDDETTTARIFFARIO = 'IDDETTTARIFFARIO',
  FATTURA = 'FATTURA',
  TIPOFATTURA = 'TIPOFATTURA',
  PRIMANOTA = 'PRIMANOTA',
  LAVAGNA = 'LAVAGNA',
  TABINDEXANAGRAFICA = 'TABINDEXANAGRAFICA',
  TABINDEXMOVIMENTI = 'TABINDEXMOVIMENTI',
  IDDETTCORSO = 'IDDETTCORSO',
  NOMESTUDIOATTIVO = 'NOMESTUDIOATTIVO',
  STUDIOATTIVO = 'STUDIOATTIVO',
  VERSION = 'VERSION',
  PREVENTIVO = 'PREVENTIVO',
  CURRENTURL = 'CURRENTURL',
  CURRENTSITE = 'CURRENTSITE',
  PRIVACYACCEPTED = 'PRIVACYACCEPTED'
}
export enum Piattaforma {
  Anagrafica = 1,
  Servizi,
  Social
}
export enum TipoUtente {
  Nazionale = 1,
  Regionale = 2,
  Provinciale = 3,
  Socio = 4,
  SocioEsecutivo = 5,
  NonSocio = 6,
  Fondazione = 7
}
export enum TipoAdesioneTAB {
  MesePrevenzione = 0,
  OCD = 1,
  ANDIDentistiAgosto = 2
}
export enum TipoEvento {
  OCD = 1,
  MesePrevenzione = 2,
  ANDIDentistiAgosto = 3
}
export class Costanti {
  public static FILTER_FROM_YEAR = 2018;
  public static TRADUZIONI = [];
  public static CONF = environment.production ? 'aws' : 'dev'; // 'aws'; //
  // static urlDominio = {
  //   dev: 'http://localhost:4200/',
  //   aws: window.location.protocol + '//' + window.location.host + '/' + window.location.pathname.split('/')[1]
  // };
  static urlApi =
    environment.apiServer.protocol + '://' + environment.apiServer.domain + ':' + environment.apiServer.port + '/'; // 'https://apibrainv3.exacloud.it/';
  static urlNppApi =
    environment.nppApiServer.protocol +
    '://' +
    environment.nppApiServer.domain +
    ':' +
    environment.nppApiServer.port +
    '/';
  static urlApiCorsi = environment.apiCorsi;
  static urlApi8108 = environment.api8108;
  static urlApiGdpr = environment.apiGdpr;
  static urlCopertina(path?: string | null): string | undefined {
    if (!path) {
      return undefined;
    }
    if (/^https?:\/\//i.test(path)) {
      return path;
    }
    return Costanti.urlFileBase.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
  }
  //   {
  //   dev: 'http://192.168.1.105:8083/', //'http://localhost:8083/', // 'http://localhost:8083/', //
  //   aws: 'https://apibrain.exacloud.it/'
  // };
  static urlFile = 'https://d3p8z2rnbqiyup.cloudfront.net/servizi/';
  public static urlFileAlt = `https://d1ppidsumzybah.cloudfront.net/servizi/`;
  public static urlFileBase = `https://d1ppidsumzybah.cloudfront.net/`;
  //   {
  //   dev: 'https://d3p8z2rnbqiyup.cloudfront.net/servizi/',
  //   aws: 'https://d3p8z2rnbqiyup.cloudfront.net/servizi/'
  // };
  static apiKeyPaypal = {
    dev: 'AWcuqOIIYvomt1zocM_Vhk60tweQaUF-ccFylXtwPIUtMOaevYttTQpES-x5UTvLMLJMetBDWJ_tAXcp',
    aws: 'ATYSKwp8z6wtKs56uZ3Etxf1L7wnjPGMpj42xbBIIEtEkTlZwndIdsHPFcoVB61O39m29b5XAZZgY2JP'
  };
  public static APIURL = Costanti.urlApi; // [Costanti.CONF];
  public static NPP_APIURL = Costanti.urlNppApi;
  public static URLASSET = Costanti.urlFile;

  public static APIPAYPAL = Costanti.apiKeyPaypal[Costanti.CONF];
  public static DOMINIOASSETS =
    window.location.protocol + '//' + window.location.host + '/' + window.location.pathname.split('/')[1];
  public static DOMINIO =
    window.location.protocol + '//' + window.location.host + '/' + window.location.pathname.split('/')[1] + '#/';
  public static TOKEN = 'TOKEN';
  public static TOKENPASS = 'TOKENPASS';
  public static IDDETTSOCIO = 'IDDETT';
  public static TIPO_VERSAMENTO = 'TIPO_VERSAMENTO';
  public static IDDETTRIMBORSO = 'IDDETTRIMBORSO';
  public static DEFAULTPERPG = 20;
  public static FBCONFIG = environment.FBCONFIG;
  public static TIPOFATTURE = [
    // { id: '-1', descrizione: 'Non specificato' },
    { id: '0', descrizione: 'TD01 - Fattura' },
    { id: '1', descrizione: 'TD02 - Fattura di acconto' },
    { id: '2', descrizione: 'TD04 - Nota di credito' },
    { id: '5', descrizione: 'TD05 - Nota di debito' },
    { id: '3', descrizione: 'TD06 - Parcella' },
    { id: '9', descrizione: 'TD16 - Integrazione fattura reverse charge interno' },
    { id: '6', descrizione: 'TD17 - Integrazione o Autofattura per acquisto di servizi dall’estero' },
    { id: '7', descrizione: 'TD18 - Integrazione per acquisto di beni intracomunitari' },
    {
      id: '8',
      descrizione: 'TD19 - Integrazione o Autofattura per acquisto di beni art. 17, comma 2 del D.P.R. n. 633/1972'
    },
    { id: '4', descrizione: 'TD26 - Cessione di beni ammortizzabili e per passaggi interni' }
  ];
  public static Pattern = {
    CODICE_FISCALE: /[a-z]{6}\d{2}[a-z]\d{2}[a-z]\d{3}[a-z]/i,
    PARTITA_IVA: /\d{11}/,
    CARTA_IDENTITA: /[a-z]{2}\d{6}(?:\d|[a-z])/i
  };
  public static PREFERENZENATURABOLLO = [
    {
      value: 1,
      viewValue: 'Non soggetto - altri casi'
    },
    {
      value: 2,
      viewValue: 'Non soggette - Art. 1 comma. 54 - 89 L. 190/2014 e successive modifiche'
    }
  ];
  public static NATURE = [
    { value: 'N0', viewValue: 'Non esente', rif_normativo: '' },
    { value: 'N1', viewValue: 'N1 - ', rif_normativo: 'Escluso Art. 15 DPR 633/72' },
    {
      value: 'N2.1',
      viewValue: 'N2.1 - ',
      rif_normativo: 'Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72'
    },
    { value: 'N2.2', viewValue: 'N2.2 - ', rif_normativo: 'Non soggette - altri casi' },
    {
      value: 'N2.2',
      viewValue: 'N2.2 - ',
      rif_normativo: 'Non soggette - Art. 1 comma. 54 - 89 L. 190/2014 e successive modifiche'
    },
    { value: 'N3.1', viewValue: 'N3.1 - ', rif_normativo: 'non imponibili - esportazioni' },
    { value: 'N3.2', viewValue: 'N3.2 - ', rif_normativo: 'non imponibili - cessioni intracomunitarie' },
    { value: 'N3.3', viewValue: 'N3.3 - ', rif_normativo: 'non imponibili - cessioni verso San Marino' },
    {
      value: 'N3.4',
      viewValue: 'N3.4 - ',
      rif_normativo: `non imponibili - operazioni assimilate alle cessioni all'esportazione`
    },
    { value: 'N3.5', viewValue: 'N3.5 - ', rif_normativo: `non imponibili - a seguito di dichiarazioni d'intento` },
    {
      value: 'N3.6',
      viewValue: 'N3.6 - ',
      rif_normativo: 'non imponibili - altre operazioni che non concorrono alla formazione del plafond'
    },

    { value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 DPR 633/72' },
    { value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 comma 1 n 27-quinquies DPR 633/72' },
    { value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Escluso Art. 74 DPR 633/72' },
    { value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Regime del margine Art. 36 41/95' },

    {
      value: 'N6.1',
      viewValue: 'N6.1 - ',
      rif_normativo: 'inversione contabile - cessione di rottami e altri materiali di recupero'
    },
    { value: 'N6.2', viewValue: 'N6.2 - ', rif_normativo: 'inversione contabile - cessione di oro e argento puro' },
    { value: 'N6.3', viewValue: 'N6.3 - ', rif_normativo: 'inversione contabile - subappalto nel settore edile' },
    { value: 'N6.4', viewValue: 'N6.4 - ', rif_normativo: 'inversione contabile - cessione di fabbricati' },
    { value: 'N6.5', viewValue: 'N6.5 - ', rif_normativo: 'inversione contabile - cessione di telefoni cellulari' },
    { value: 'N6.6', viewValue: 'N6.6 - ', rif_normativo: 'inversione contabile - cessione di prodotti elettronici' },
    {
      value: 'N6.7',
      viewValue: 'N6.7 - ',
      rif_normativo: 'inversione contabile - prestazioni comparto edile e settori connessi'
    },
    { value: 'N6.8', viewValue: 'N6.8 - ', rif_normativo: 'inversione contabile - operazioni settore energetico' },
    { value: 'N6.9', viewValue: 'N6.9 - ', rif_normativo: 'inversione contabile - altri casi' }
  ];
  public static NATUREPAZIENTE = [
    { value: 'N0', viewValue: 'Non esente', rif_normativo: '' },
    { value: 'N1', viewValue: 'N1 - ', rif_normativo: 'Escluso Art. 15 DPR 633/72' },
    {
      value: 'N2.1',
      viewValue: 'N2.1 - ',
      rif_normativo: 'Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72'
    },
    { value: 'N2.2', viewValue: 'N2.2 - ', rif_normativo: 'Non soggette - altri casi' },
    {
      value: 'N2.2',
      viewValue: 'N2.2 - ',
      rif_normativo: 'Non soggette - Art. 1 comma. 54 - 89 L. 190/2014 e successive modifiche'
    },
    { value: 'N3.1', viewValue: 'N3.1 - ', rif_normativo: 'non imponibili - esportazioni' },
    { value: 'N3.2', viewValue: 'N3.2 - ', rif_normativo: 'non imponibili - cessioni intracomunitarie' },
    { value: 'N3.3', viewValue: 'N3.3 - ', rif_normativo: 'non imponibili - cessioni verso San Marino' },
    {
      value: 'N3.4',
      viewValue: 'N3.4 - ',
      rif_normativo: `non imponibili - operazioni assimilate alle cessioni all'esportazione`
    },
    { value: 'N3.5', viewValue: 'N3.5 - ', rif_normativo: `non imponibili - a seguito di dichiarazioni d'intento` },
    {
      value: 'N3.6',
      viewValue: 'N3.6 - ',
      rif_normativo: 'non imponibili - altre operazioni che non concorrono alla formazione del plafond'
    },

    { value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 DPR 633/72' },
    { value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 comma 1 n 27-quinquies DPR 633/72' },
    { value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Escluso Art. 74 DPR 633/72' },
    { value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Regime del margine Art. 36 41/95' },

    {
      value: 'N6.1',
      viewValue: 'N6.1 - ',
      rif_normativo: 'inversione contabile - cessione di rottami e altri materiali di recupero'
    },
    { value: 'N6.2', viewValue: 'N6.2 - ', rif_normativo: 'inversione contabile - cessione di oro e argento puro' },
    { value: 'N6.3', viewValue: 'N6.3 - ', rif_normativo: 'inversione contabile - subappalto nel settore edile' },
    { value: 'N6.4', viewValue: 'N6.4 - ', rif_normativo: 'inversione contabile - cessione di fabbricati' },
    { value: 'N6.5', viewValue: 'N6.5 - ', rif_normativo: 'inversione contabile - cessione di telefoni cellulari' },
    { value: 'N6.6', viewValue: 'N6.6 - ', rif_normativo: 'inversione contabile - cessione di prodotti elettronici' },
    {
      value: 'N6.7',
      viewValue: 'N6.7 - ',
      rif_normativo: 'inversione contabile - prestazioni comparto edile e settori connessi'
    },
    { value: 'N6.8', viewValue: 'N6.8 - ', rif_normativo: 'inversione contabile - operazioni settore energetico' },
    { value: 'N6.9', viewValue: 'N6.9 - ', rif_normativo: 'inversione contabile - altri casi' },

    // { deprecated: true, value: 'N0', viewValue: 'Non esente', rif_normativo: '' },
    { deprecated: true, value: 'N1', viewValue: 'N1 - ', rif_normativo: 'Escluso Art. 15 DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Escluso Art. 13 5C DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Fuori campo IVA Art. 2 DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Fuori campo IVA Art. 3 DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Fuori campo IVA Art. 4 DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Fuori campo IVA Art. 7 DPR 633/72' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Regime dei minimi Art. 1 L. 244/2007' },
    { deprecated: true, value: 'N2', viewValue: 'N2 - ', rif_normativo: 'Regime forfettario Art. 1 L. 190/2014' },
    { deprecated: true, value: 'N2.2', viewValue: 'N2.2 - ', rif_normativo: 'Non soggette - altri casi' },
    { deprecated: true, value: 'N3', viewValue: 'N3 - ', rif_normativo: 'Non Imponibile Art. 8 DPR 633/72' },
    { deprecated: true, value: 'N3', viewValue: 'N3 - ', rif_normativo: 'Non Imponibile Art. 9 DPR 633/72' },
    { deprecated: true, value: 'N3', viewValue: 'N3 - ', rif_normativo: 'Non Imponibile Art. 41 DL 331/93' },
    { deprecated: true, value: 'N3', viewValue: 'N3 - ', rif_normativo: 'Non Imponibile Art. 74 DPR 633/72' },
    { deprecated: true, value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 DPR 633/72' },
    { deprecated: true, value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10-quinques DPR 633/72' },
    { deprecated: true, value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 comma 1 n 18 DPR 633/72' },
    { deprecated: true, value: 'N4', viewValue: 'N4 - ', rif_normativo: 'Esente Art. 10 comma 1 n 27 DPR 633/72' },
    { deprecated: true, value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Escluso Art. 74 DPR 633/72' },
    { deprecated: true, value: 'N5', viewValue: 'N5 - ', rif_normativo: 'Regime del margine Art. 36 41/95' },
    { deprecated: true, value: 'N6', viewValue: 'N6 - ', rif_normativo: 'Reverse charge Art. 17 DPR 633/72' },
    { deprecated: true, value: 'N6', viewValue: 'N6 - ', rif_normativo: 'Reverse charge Art. 74 DPR 633/72' }
  ];
  public static MSGINVIOTS2021 = ``;
  // `<b>Caro Socio,</b><br>
  // <b>nel 2021 il Sistema Tessera Sanitaria si è aggiornato.</b> <br>
  // <b>Pertanto, per ragioni tecniche, a gennaio potrai ancora inviare le fatture relative all'anno 2020,
  // mentre l'invio di tutte quelle relative al 2021 ti sarà reso disponibile a partire dal 1 febbraio; a titolo di esempio le fatture emesse a Gennaio 2021
  // potranno essere inviate al Sistema TS entro il 28 Febbraio 2021 e così via per i mesi successivi,
  // quindi l'invio andrà effettuato come regola entro l'ultimo giorno del mese successivo al mese di emissione della fattura.</b>`;
  public static limiti = [
    { value: 1, viewValue: 'Con limite' },
    { value: 0, viewValue: 'Senza limite' }
  ];
  public static elemBaseSelect = { value: '', viewValue: 'Non specificato' };

  public static categorie = [
    Costanti.elemBaseSelect,
    { value: 'Accessori', viewValue: 'Accessori' },
    { value: 'Disinfezione', viewValue: 'Disinfezione' },
    { value: 'File denti diatorici', viewValue: 'File denti diatorici' },
    { value: 'Generica', viewValue: 'Generica' },
    { value: 'Gessi', viewValue: 'Gessi' },
    { value: 'Materiali di consumo', viewValue: 'Materiali di consumo' },
    { value: 'Ortodonzia fissa', viewValue: 'Ortodonzia fissa' },
    { value: 'Resine composito', viewValue: 'Resine composito' }
  ];
  public static UDIDIPIAI = {
    '(01)': 'GTIN',
    '(10)': 'Lotto di produzione',
    '(11)': 'Data di produzione',
    '(15)': 'Data di consumo preferibile',
    '(17)': 'Data di scadenza',
    '(21)': 'Numero seriale',
    '(LIC)': 'Codice produttore'
  };
  public static UDIAI = {
    CODICEPRODUTTORE: '(LIC)',
    GTIN: '(01)',
    LOTTOPRODUZIONE: '(10)',
    DATAPRODUZIONE: '(11)',
    DATACONSUMOPREF: '(15)',
    DATASCADENZA: '(17)',
    SERIALE: '(21)'
  };
}
export const MAX_LENGTH_DESC = 500;
export const MAX_LENGTH_INPUT = 255;
